import { atom } from "@reatom/core"

import { defaultQuery } from "modules/PsyCatalog/common/searchQuery"
import { services } from "modules/PsyCatalog/common/services"
import { cityAtomField } from "modules/PsyCatalog/common/models/cities"
import { competencesField } from "modules/PsyCatalog/common/models/competences"
import { methodsField } from "modules/PsyCatalog/common/models/methods"
import { formOfWorkField } from "modules/PsyCatalog/common/models/formOfWork"
import { sexField } from "modules/PsyCatalog/common/models/sex"
import { maritalStatusField } from "modules/PsyCatalog/common/models/maritalStatus"
import { hasChildrenField } from "modules/PsyCatalog/common/models/hasChildren"
import { workingWithField } from "modules/PsyCatalog/common/models/workingWith"
import { expressSlotsField } from "modules/PsyCatalog/common/models/expressSlots"
import { sessionTimeIntervalsField } from "modules/PsyCatalog/common/models/sessionTimeIntervals"
import { createRangeField } from "modules/PsyCatalog/common/models/rangeField"

export const cityAtom = cityAtomField(services)
export const formOfWorkAtom = formOfWorkField(services)
export const sexAtom = sexField(services)
export const maritalStatusAtom = maritalStatusField(services)
export const hasChildrenAtom = hasChildrenField(services)
export const priceAtom = createRangeField(services, "price")
export const ageAtom = createRangeField(services, "age")
export const competencesAtom = competencesField(services)
export const methodsAtom = methodsField(services)
export const workingWithAtom = workingWithField(services)
export const expressSlotsAtom = expressSlotsField(services)
export const sessionTimeIntervalsAtom = sessionTimeIntervalsField()
export const formAtom = atom((ctx) => ({
    city: ctx.spy(cityAtom.inputValue)?.name ?? defaultQuery.city,
    form_of_work: ctx.spy(formOfWorkAtom.inputValue),
    sex: ctx.spy(sexAtom.inputValue),
    marital_status: ctx.spy(maritalStatusAtom.inputValue),
    has_children: ctx.spy(hasChildrenAtom.inputValue),
    price_from: ctx.spy(priceAtom.inputValue)[0],
    price_to: ctx.spy(priceAtom.inputValue)[1],
    age_from: ctx.spy(ageAtom.inputValue)[0],
    age_to: ctx.spy(ageAtom.inputValue)[1],
    competences: ctx.spy(competencesAtom.inputValue),
    methods: ctx.spy(methodsAtom.inputValue),
    working_with: ctx.spy(workingWithAtom.inputValue),
    express_slots: ctx.spy(expressSlotsAtom.inputValue),
    session_time_intervals: ctx.spy(sessionTimeIntervalsAtom.inputValue),
}))
